import script from "./Section.vue?vue&type=script&lang=ts&setup=true"
export * from "./Section.vue?vue&type=script&lang=ts&setup=true"

import "./Section.vue?vue&type=style&index=0&id=6d8e1378&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d8e1378"]])

export default __exports__